import _ from "lodash";
import moment from "moment";
import react, { useState } from "react";
import { useEffect } from "react";
import { TableControl } from "../../../../components/controls";
import rubricIcon from "../../../../content/icons/grading.svg";
import SystemTypes from "../../../../SystemTypes";
import {
  contentManagementCMSTable,
  contentManagementTable,
} from "../../../../utilities/ContentUtils";
import { useAppUserManager } from "../../../../hooks/useManagers";

const ContentLibraryTable = ({
  updateContent,
  filteredContent,
  onView,
  onEdit,
  onDelete,
  onManageRubricAnswers,
}) => {
  const authMgr = useAppUserManager();
  const permissions = authMgr?.GetGlobalState()?.permissions ?? [];

  const [rows, setRows] = useState([]);
  const [columns] = useState(contentManagementCMSTable);

  useEffect(() => {
    let newRows = [];
    if (filteredContent) {
      _.each(filteredContent, (c) => {
        let HtmlTagList = "";
        _.each(c.TagIds, (x) => {
          HtmlTagList += "<div>" + x + "</div>";
        });

        let AiOnlyTags = "";
        _.each(c.AiOnlyTags, (x) => {
          AiOnlyTags += "<div>" + x + "</div>";
        });

        newRows.push({
          ...c,
          Title: (
            <div>
              <div className="title">{c.Title}</div>
              <div className="content-type">{c.ContentType}</div>
              <div className="file-name">{c.DisplayFileName}</div>
            </div>
          ),
          HtmlTagList,
          AiOnlyTags,
          IsAiAdmin: c.IsAiAdmin ? "Yes" : "No",
          IsEnabled: c.IsEnabled ? "Yes" : "No",
          HideFromLibrary: c.HideFromLibrary ? "Yes" : "No",
          LibraryVisible: c.HideFromLibrary ? "No" : "Yes",
          UseForCertification: c.UseForCertification ? "Yes" : "No",
          AiStatus: SystemTypes.AiStatusType[c.AiStatus],
        });
      });
      setRows(newRows);
    }
  }, [updateContent]);

  const handleCheckDisableAction = (row, action) => {
    if (action.toLowerCase() == "custom1") {
      return row.UseForCertification === "No" && true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="contentDisplay-list">
        <TableControl
          columns={columns}
          data={rows}
          permission="Content"
          checkDisableAction={handleCheckDisableAction}
          useIntegratedPaging={["10", "25", "50", "100"]}
          onView={(row) => onView(row.KeyId)}
          onEdit={(row) => onEdit(row.KeyId)}
          onDelete={onDelete}
          defaultSortBy={"CreatedOn"}
          defaultSortDesc={false}
          onCustom1={{
            action: (row) => (
              <img
                title="Configure Rubric Answer Key"
                src={rubricIcon}
                onClick={() => {
                  if (!handleCheckDisableAction(row, "custom1")) {
                    onManageRubricAnswers(row);
                  }
                }}
              />
            ),
          }}
        />
      </div>
    </>
  );
};

export default ContentLibraryTable;
